var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLatestSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51368 1.41312C5.69266 0.862294 6.47193 0.862293 6.6509 1.41312L7.55883 4.20744C7.63887 4.45378 7.86843 4.62056 8.12745 4.62056H11.0656C11.6447 4.62056 11.8855 5.36169 11.417 5.70212L9.04 7.42911C8.83045 7.58135 8.74277 7.85121 8.82281 8.09755L9.73074 10.8919C9.90971 11.4427 9.27926 11.9007 8.8107 11.5603L6.43371 9.83333C6.22417 9.68108 5.94042 9.68108 5.73087 9.83333L3.35388 11.5603C2.88532 11.9007 2.25487 11.4427 2.43385 10.8919L3.34178 8.09755C3.42182 7.85121 3.33413 7.58135 3.12459 7.42911L0.747598 5.70212C0.279037 5.36169 0.519845 4.62056 1.09902 4.62056H4.03714C4.29615 4.62056 4.52571 4.45378 4.60575 4.20744L5.51368 1.41312Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatestSolid);
export default __webpack_public_path__ + "static/media/latest-solid.8d471f2f6476e2dc6a8ce11e057a5f7e.svg";
export { ForwardRef as ReactComponent };